import { withDataVersion } from '@hakimo-ui/hakimo/util';
import { BugReport, DataVersion } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useReportBug(
  alarmId: string,
  onSuccess?: () => void,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/alarm/bug/${alarmId}`;

  const request = new Request(url, {
    method: 'POST',
  });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, BugReport | null>(request, {
    onSuccess,
  });
}

export default useReportBug;
